// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SingleImageUploadField_mainContainer__1EO_u","inputArea":"SingleImageUploadField_inputArea__1BnJO","uploadButton":"SingleImageUploadField_uploadButton__2ItnC"};